import { map, Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import {
  SocialAuthService,
  GoogleLoginProvider,
  FacebookLoginProvider,
} from 'angularx-social-login';

const BACKEND_URL = environment.API_URL;

@Injectable({ providedIn: 'root' })
export class AuthService {
  constructor(
    private http: HttpClient,
    private _socialAuthService: SocialAuthService
  ) {}

  register(value: any): Observable<any> {
    return this.http.post<any>(BACKEND_URL + 'registeration', value);
  }

  verifyEmail(value: any): Observable<any> {
    const sendData = value;

    return this.http.post<any>(BACKEND_URL + 'verification', sendData);
  }

  login(value: any): Observable<any> {
    return this.http
      .post<{
        user: any;
        token: string;
        message: string;
        status: boolean;
        verified: number;
        return_url: string;
      }>(BACKEND_URL + 'login', value)
      .pipe(
        map(response => ({
          token: response?.token,
          status: response?.status,
          message: response?.message,
          verified: response?.verified,
          returnUrl: response?.return_url,
        }))
      );
  }

  logout(): Observable<any> {
    this._socialAuthService.signOut();

    return this.http
      .post<any>(BACKEND_URL + 'logout', {})
      .pipe(map(response => response));
  }

  submitOTPAdmin(otp: string): Observable<any> {
    return this.http
      .post(BACKEND_URL + 'verifyOtp', { otp })
      .pipe(map(response => response));
  }

  resendOTPAdmin() {
    return this.http.get<any>(BACKEND_URL + 'resendOtp');
  }

  resendEmailConfirm(email: string): Observable<any> {
    return this.http.post<any>(BACKEND_URL + 'verification/resend', { email });
  }

  signupNewsLetter(email: string): Observable<any> {
    return this.http.post<any>(BACKEND_URL + 'newsletter', {
      email,
      ip_address: localStorage.getItem('my-ip'),
    });
  }

  signInWithGoogle(): any {
    return this._socialAuthService.signIn(GoogleLoginProvider.PROVIDER_ID);
  }

  googleSignIn(data: any): Observable<any> {
    return this.http
      .post<any>(BACKEND_URL + 'google-signup', data)
      .pipe(map(response => response?.token));
  }

  facebookSignIn(data: any): Observable<any> {
    return this.http
      .post<any>(BACKEND_URL + 'facebook-signup', data)
      .pipe(map(response => response?.token));
  }

  signInWithFacebook() {
    return this._socialAuthService.signIn(FacebookLoginProvider.PROVIDER_ID);
  }
}
